import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const OrderPlacedStep = ({ isGuest }) => {
    const navigate = useNavigate();

    return (
        <Box sx={{ textAlign: 'center', mt: 12 }}>
            <Typography variant="h4" gutterBottom>
                <FormattedMessage id="order_placed_title" />
            </Typography>
            {isGuest ? (
                <>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        <FormattedMessage id="order_placed_guest" />
                    </Typography>
                    <Button variant="contained" sx={{ bgcolor: "text.primary", color: "background.default" }} onClick={() => navigate("/")}>
                        <FormattedMessage id="back_to_home" />
                    </Button>
                </>
            ) : (
                <>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        <FormattedMessage id="order_placed_user" values={{ b: (chunks) => <b>{chunks}</b> }} />
                    </Typography>
                    <Button variant="contained" sx={{ bgcolor: "text.primary", color: "background.default" }} onClick={() => navigate("/profile/orders")}>
                        <FormattedMessage id="go_to_my_orders" />
                    </Button>
                </>
            )}
        </Box>
    );
};

export default OrderPlacedStep;
